var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-default-no-valid"},[(_vm.isShowHeader)?_c('OrganismsCommonHeader',{on:{"clickMenuBtn":_vm.clickMenuBtn}}):_vm._e(),_c('router-view',{staticClass:"font-setting"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }